export default __webpack_public_path__ + "static/media/icon_three.0538127c.png";